import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=cbab01ca&scoped=true"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=cbab01ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab01ca",
  null
  
)

export default component.exports